export class OrderRefundedStatus {
  public code!: string;
  public translationKey!: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_REFUNDED_STATUS: any = {
  TOTALLY_REFUNDED: new OrderRefundedStatus({ code: 'TOTALLY_REFUNDED', translationKey: 'LABEL.TOTALLY_REFUNDED' }),
  PARTIALLY_REFUNDED: new OrderRefundedStatus({
    code: 'PARTIALLY_REFUNDED',
    translationKey: 'LABEL.PARTIALLY_REFUNDED',
  }),
  NOT_REFUNDED: new OrderRefundedStatus({ code: 'NOT_REFUNDED', translationKey: 'LABEL.NOT_REFUNDED' }),
};
